<template>
  <div class="home">
    <div id="top">
      <swiper style="height: 600px" :options="swiperOptions">
        <swiper-slide v-for="(image, index) in images" :key="index">
          <img class="swiper-slide-image" :src="image" alt="轮播图图片">
        </swiper-slide>
        <!-- 分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="top-line">
        <div class="line">
          <div class="logo"></div>
          <div class="top-right">
            <div class="icon_notice"></div>
            <div class="text_notice">扫码根据提示下载安装商家客户端或扫码进入商家/派送/用户小程序开启您的享食之旅</div>
          </div>
        </div>
      </div>
    </div>
    <div class="code-area">
      <div class="code-list">
        <div class="code">
          <img class="code-image" src="http://img.lovexshi.com/front/unionapp.jpg">
          <div class="code-title">用户小程序</div>
        </div>
        <div class="code">
          <img class="code-image" src="http://img.lovexshi.com/front/business.png">
          <div class="code-title">商家客户端</div>
        </div>
        <div class="code">
          <img class="code-image" src="http://img.lovexshi.com/front/deliverer.png">
          <div class="code-title">骑手客户端</div>
        </div>

        <div class="code">
          <img class="code-image" src="http://img.lovexshi.com/front/printtool.png">
          <div class="code-title">打印工具</div>
        </div>
      </div>
      <div class="opt-list">
<!--        <div class="customer-service" @click="openService()"></div>-->
<!--        <div class="background" @click="toPcControl()"></div>-->
      </div>
    </div>
    <div class="foot">
      <div class="text-list">
        <div class="foot-text">为了防范电信网络诈骗，如网民接到962110电话，请立即接听</div>
<!--        <div class="foot-text">地址：北京市顺义区杨镇地区顺平路下营村段</div>-->
        <div class="foot-text"> Copyright ©2023年11月28-现在 京ICP备2023038232号-1  北京己亥网络科技有限公司 ICP证书：京B2-20240547 网络食品交易第三方平台-京市监网食备20240011841
        </div>
<!--        <div class="foot-text">出版物经营许可证（京）批字第Y8813号广播电视节目制作经营许可证（京）字第03283号 网络文化经营许可证-->
<!--          京网文{2022}1460-055号-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppHome',
  components: {},
  data() {
    return {
      images: [
        'http://img.lovexshi.com/front/banner1.png',
        'http://img.lovexshi.com/front/banner2.png',
        'http://img.lovexshi.com/front/banner3.png'
      ],
      swiperOptions: {
        autoplay: {
          delay: 3000, // 自动播放间隔，单位为毫秒
          disableOnInteraction: false // 用户交互后不停止自动播放
        },
        speed: 1000, // 切换幻灯片的速度，单位为毫秒
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 分页器可点击
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods:{
    openService(){

    },
    toPcControl(){
      window.open('https://www.lovexshi.com/')
    }
  }
}

</script>
<style lang="less" scoped>
@import "./index.less";
</style>
